import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: enrolments.ENROLError.
export default class EnrolError extends Fragment {
  declare [Type]: 'enrolments/nz-moe/enrol-error';

  @attr('number', { defaultValue: 0 })
  declare code: number;

  @attr('string', { defaultValue: '' })
  declare message: string;

  @attr('string', { defaultValue: '' })
  declare messagePath: string;

  @attr('string', { defaultValue: '' })
  declare technicalMessage: string;

  @attr('string', { defaultValue: '' })
  declare technicalMessagePath: string;
}
